import { createContext } from 'react';
import { SEPARATOR, SIZE } from './constants';
export const BreadcrumbsContext = createContext({
    hidden: false,
    size: SIZE.S,
    separator: SEPARATOR,
});
